export const WRAPPED_SMART_CONTRACT_ORACLE_URL: Readonly<string> =
  process.env.VUE_APP_WRAPPED_SMART_CONTRACT_ORACLE_URL ?? '';
